<div *ngIf="type !== 'textarea'" [class.c-input--floating]="isFloating()" [class.is-error]="hasError()" class="c-input has-floatable-label is-active">
	<div class="c-input__field-holder">
		<label [for]="name" class="c-input__label is-floatable">{{ label }}</label>

		@switch (type) {
			@case ('number') {
				<input
					(input)="formatNumber()"
					[attr.autocomplete]="autocomplete === false ? 'none' : null"
					[formControl]="control"
					[id]="name"
					[max]="max"
					[min]="min"
					autocomplete="off"
					type="number"
				/>
			}
			@case	('price') {
				<input
					(input)="formatPrice()"
					[attr.autocomplete]="autocomplete === false ? 'none' : null"
					[formControl]="control"
					[id]="name"
					[max]="max"
					[min]="min"
					autocomplete="off"
					class="c-input--price"
					type="text"
				/>

				@if (isFloating()) {
					<span class="c-input__icon">&euro;</span>
				}
			}
			@case	('price-decimal') {
				<input
					(blur)="formatPriceDecimal()"
					(keydown)="allowPriceDecimalKeys($event)"
					[attr.autocomplete]="autocomplete === false ? 'none' : null"
					[formControl]="control"
					[id]="name"
					[max]="max"
					[min]="min"
					autocomplete="off"
					class="c-input--price"
					type="text"
				/>

				@if (isFloating()) {
					<span class="c-input__icon">&euro;</span>
				}
			}
			@default {
				<input
					[attr.autocomplete]="autocomplete === false ? 'none' : null"
					[formControl]="control"
					[id]="name"
					[type]="type"
					autocomplete="off"
					maxlength="200"
				/>
			}
		}
	</div>

	<ng-container *ngIf="innerTemplate" [ngTemplateOutlet]="innerTemplate"></ng-container>
</div>

<div *ngIf="type === 'textarea'" [class.c-input__maxlength]="maxlength" [class.is-error]="hasError()" class="c-input is-active">
	<div class="c-input__field-holder">
		<textarea [class.large]="large" [formControl]="control" [maxlength]="maxlength" [placeholder]="label"></textarea>

		<p *ngIf="maxlength" class="c-input__maxlength-text">
			<ng-container *ngIf="innerTemplate" [ngTemplateOutletContext]="{ $implicit: getLength() }" [ngTemplateOutlet]="innerTemplate"></ng-container>
			<ng-container *ngIf="!innerTemplate">{{ getLength() }} van {{ maxlength }} tekens resterend</ng-container>
		</p>
	</div>
</div>

<ng-content></ng-content>
